import React from 'react'
import classnames from 'classnames'
import { FORM_CONTROL_CLASS } from './constants'
import useInputError from 'hooks/useInputError'
import ProfileErrorMessage from './ProfileErrorMessage'
import PropTypes from 'prop-types'
import WarningDot from 'components/Profile/WarningDot'

const ProfileInput = ({
  errorMessage,
  onChange,
  onError,
  onInvalid,
  classNames,
  children,
  showRequired,
  ...rest
}) => {
  const { errorMessage: nativeErrorMessage, handleError, setErrorMessage } = useInputError(onError)
  const error = errorMessage || nativeErrorMessage

  return (
    <>
      <div className="relative">
        <input
          className={classnames(FORM_CONTROL_CLASS, classNames.input, 'md:text-center')}
          onChange={e => {
            setErrorMessage(null)
            onChange(e)
          }}
          onInvalid={e => {
            handleError(e)
            onInvalid(e)
          }}
          {...rest}
        />
        {showRequired && !rest.value && (
          <WarningDot className="absolute top-1/2 right-4 transform -translate-y-1/2" />
        )}
        {!!children && children}
      </div>
      {error && <ProfileErrorMessage>{error}</ProfileErrorMessage>}
    </>
  )
}

ProfileInput.defaultProps = {
  classNames: {},
  onError: e => e.target.validationMessage,
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
  onInvalid: () => {},
}

ProfileInput.propTypes = {
  classNames: PropTypes.object,
  value: PropTypes.string,
  onError: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onInvalid: PropTypes.func,
  showRequired: PropTypes.bool,
}

export default ProfileInput
